import { DateTime } from 'luxon';

const luxonPool = new Map();

export default function getPooledLuxon(dayString) {
    if (!luxonPool.has(dayString)) {
        luxonPool.set(dayString, DateTime.fromISO(dayString));
    }

    return luxonPool.get(dayString);
}
